import React from "react";
import NewsCard from "./NewsCard";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";

function NewsSection() {
  const { news } = useContext(UserContext);

  const newsElements = news.map((item) => (
    <NewsCard news={item} key={item._id} />
  ));

  return (
    <section className="news_section">
      <h2>Leatest News</h2>
      <div className="news_container">{newsElements}</div>
    </section>
  );
}

export default NewsSection;
